export const COMMON_REQ = 'cris/session/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/session/COMMON_REQ_FAIL';
export const LOAD_SESSION_FAIL = 'cris/session/LOAD_SESSION_FAIL';
export const LOAD_SESSION_SUCCESS = 'cris/session/LOAD_SESSION_SUCCESS';
export const REMOVE_SESSION_SUCCESS = 'cris/session/REMOVE_SESSION_SUCCESS';
export const SWITCH_ROLE_REQ = 'cris/session/SWITCH_ROLE_REQ';
export const SWITCH_ROLE_SUCCESS = 'cris/session/SWITCH_ROLE_SUCCESS';
export const UPDATE_SESSION_USER = 'cris/session/UPDATE_SESSION_USER';
export const COMMON_REQ_LIVE = 'cris/session/COMMON_REQ_LIVE';

const initialState = {
	isLoading: true,
	error: null,
	active_role_id: null,
	active_role_type: null,
	language: null,
	permission_names: null,
	token: localStorage.getItem("token"),
	user_id: null,
	user_roles: null,
	user: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_LIVE:
			return state;

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error,
			};

		case LOAD_SESSION_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error,
				token: null
			};

		case SWITCH_ROLE_REQ:
			return {
				...state,
				isLoading: true
			};

		case SWITCH_ROLE_SUCCESS:
		case LOAD_SESSION_SUCCESS:
			const {user, session} = action.payload.data;
			return {
				...state,
				isLoading: false,
				error: null,
				user,
				...session
			};

		case REMOVE_SESSION_SUCCESS:
			localStorage.removeItem("token");
			return {
				...initialState,
				isLoading: false,
				token: null
			};

		case UPDATE_SESSION_USER:
			const {updatedUser} = action;
			return {
				...state,
				user: updatedUser
			};
	
		default:
			return state;
	}
}